import * as React from "react";
import * as ReactDOM from "react-dom";
import classnames from "classnames";
import moment from 'moment';

import DatePicker from 'react-datepicker';
const datePickerStyles = require('react-datepicker/dist/react-datepicker.css');

const styles = require('./DateRange.scss');
const bootstrapStyles = require('../BootstrapHelper.local.css');

interface Props
{
    locale: string;
    fromTitle: string;
    toTitle: string;
    buttonTitle: string;
    
    disabled?: boolean;
    className?: string;

    fromDate?: moment.Moment;
    toDate?: moment.Moment;

    setFromDate: (moment: moment.Moment) => void;
    setToDate: (moment: moment.Moment) => void;
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
} 

// DateRange component uses 3d party react-datepicker component
// The structure is simple: [react-datepicker] ––– [react-datepicker] [Apply button]
export class DateRange extends React.Component<Props>
{
    render()
    {
        const {
            className,
            disabled,
            fromDate, setFromDate, fromTitle,
            toDate, setToDate, toTitle,
            buttonTitle, onClick,
            locale,
        } = this.props;

        const dpClassName=classnames('form-control text-center', styles.Input);
        const btnClassName=classnames('btn btn-default', bootstrapStyles.MarginLeft);
        return (
            <div className={classnames(styles.DateRange, className)}>
                <DatePicker locale={locale} className={dpClassName} disabled={disabled}
                    selected={fromDate}
                    onChange={setFromDate} placeholderText={fromTitle}/>
                <span> – </span>
                <DatePicker locale={locale} className={dpClassName} disabled={disabled}
                    selected={toDate}
                    onChange={setToDate} placeholderText={toTitle}/>

                <button className={btnClassName} style={{float: 'right'}} disabled={disabled || !fromDate && !toDate}
                    onClick={onClick}>{buttonTitle}</button>
            </div>
        );        
    }
}


// WEBPACK FOOTER //
// ./src/components/DateRange/index.tsx